import { isNativeShell } from "@/lib/oauthRedirect";

/**
 * Eligibility and flag handling for the onboarding notifications screen.
 * Kept free of React so the rules can be unit-tested directly.
 */

export const NOTIF_DISMISS_KEY = "grounded_notif_prompt_dismissed";
export const NOTIF_PERMISSION_GRANTED_KEY = "grounded_push_permission_granted";
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

export const NOTIFICATIONS_PLACEMENT_FLAG = "onboarding_notifications_placement";
/** after_about_you is the only placement since round 2 Part B; the other two stay for old events. */
export type NotificationsPlacement = "after_celebration" | "after_first_save" | "after_about_you";
/** Variant A. Used whenever the flag is missing, errors, or returns junk. */
export const DEFAULT_NOTIFICATIONS_PLACEMENT: NotificationsPlacement = "after_celebration";

/** Normalise whatever PostHog hands back into a variant we can render. */
export function resolveNotificationsPlacement(raw: unknown): NotificationsPlacement {
  return raw === "after_first_save" ? "after_first_save" : DEFAULT_NOTIFICATIONS_PLACEMENT;
}

function dismissedRecently(): boolean {
  try {
    const raw = localStorage.getItem(NOTIF_DISMISS_KEY);
    if (!raw) return false;
    const ts = Number(raw);
    if (!Number.isFinite(ts)) return false;
    return Date.now() - ts < SEVEN_DAYS_MS;
  } catch {
    return false;
  }
}

/**
 * Show the notifications screen only inside the phone app, and only to someone
 * who has not already resolved the ask. Existing users who granted or recently
 * declined see nothing new.
 */
export function shouldOfferNotificationsScreen(): boolean {
  if (!isNativeShell()) return false;
  try {
    if (localStorage.getItem(NOTIF_PERMISSION_GRANTED_KEY)) return false;
  } catch { /* ignore */ }
  return !dismissedRecently();
}

/** Record a decline so neither the screen nor the browse card nags again soon. */
export function recordNotificationsDecline(): void {
  try {
    localStorage.setItem(NOTIF_DISMISS_KEY, Date.now().toString());
  } catch { /* ignore */ }
}
